<template>
  <div class="add-staff-page">
    <div class="add-staff-page__header md-layout">
      <div class="md-layout-item">
        <div class="nav-link" @click="goToPreviousPage">
          <i class="fas fa-chevron-left"></i>
          <span>{{ $t("student.add_new_student") }}</span>
        </div>
      </div>
    </div>
    <validation-form @on-submit="addStudent">
      <div class="md-layout md-gutter">
        <div class="md-layout-item"></div>
        <div class="md-layout-item">
          <Avatar
            :defaultUrl="avatarUrl"
            :s3FolderPath="s3FolderPath"
            @on-upload-s3-success="onUploadS3Success"
          />
        </div>
        <div class="md-layout-item"></div>
      </div>

      <personal-information
        ref="personalInfo"
        :path="path"
        :serverValidations="serverValidations"
      ></personal-information>

      <footer class="flex justify-center">
        <md-button @click="goToPreviousPage">{{
          $t("common.cancel")
        }}</md-button>
        <md-button type="submit" class="md-success ml-4">{{
          $t("common.add")
        }}</md-button>
      </footer>
    </validation-form>
    <!-- warning-duplicte-student -->
    <common-modal
      height="auto"
      width="40%"
      :name="duplicateAdd"
      :primaryAction="primaryAction"
      :secondaryActions="secondaryActions"
      :title="duplicateTitle"
    >
      <template #modal-body>
        <warning-form :duplicateAccount="duplicateAccount"></warning-form>
      </template>
    </common-modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { service_paths } from "@/constants/Services";
import { hasHistory, genErrMsgOj, getId } from "@/helpers/utils";
import { student_router_names } from "@/routes/routes";
import PersonalInformation from "./AccountDetail/Tabs/PersonalInformation";
import { Message } from "@/helpers/utils";
import Avatar from "@/components/Base/Avatar";
import AWSConst from "@/constants/AWS";
import CommonModal from "../../components/Base/CommonModal.vue";
import WarningForm from "./WarningForm.vue";
import pick from "lodash/pick";
export default {
  components: {
    PersonalInformation,
    Avatar,
    CommonModal,
    WarningForm
  },
  name: "AddStudentPage",
  data() {
    return {
      path: service_paths.students,
      serverValidations: {},
      avatarUrl: "",
      s3FolderPath: `${AWSConst.S3_STAFFS_UPLOAD_PATH}/avatars`,
      duplicateAdd: "",
      duplicateForm: {},
      duplicateAccount: {
        total: null,
        data: []
      },
      duplicateTitle: `${this.$t("class.student_col_warning")}!`,
      primaryAction: {
        title: "common.add",
        action: this.doSubmit
      },
      secondaryActions: [
        {
          title: "common.cancel",
          action: () => {
            this.$modal.hide(this.duplicateAdd);
          }
        }
      ]
    };
  },
  methods: {
    onUploadS3Success(savedLink) {
      this.avatarUrl = savedLink;
      Message.success("staff.update_avt_success");
    },
    doSubmit() {
      this.fetchStudent(this.duplicateForm);
      this.$modal.hide(this.duplicateAdd);
    },
    async addStudent() {
      const formData = await this.$refs.personalInfo.getFormData();
      formData.avatar_url = this.avatarUrl;
      this.duplicateForm = formData;
      await this.duplicteStudent();
      if (this.duplicateAccount.data.length) {
        this.$modal.show(this.duplicateAdd);
      } else {
        this.fetchStudent(formData);
      }
    },
    fetchStudent(formData) {
      const errMsg = this.$t("common.form_invalid");
      this.$axios
        .post(service_paths.students, formData, true, {}, errMsg)
        .then(({ data }) => {
          Swal.fire({
            title: this.$t("student.added"),
            text: this.$t("common.add_success"),
            type: "success",
            confirmButtonClass: "md-button md-success btn-fill",
            buttonsStyling: false
          }).then(() => {
            this.$router.push({
              name: student_router_names.detailPage,
              params: {
                id: getId(data)
              }
            });
          });
        })
        .catch(error => {
          const errData = error.response?.data;
          if (errData) {
            this.serverValidations = genErrMsgOj(errData.messages);
          }
        });
    },
    async duplicteStudent() {
      await this.$axios
        .post(`${service_paths.students}/duplicate-warning`, this.duplicateForm)
        .then(res => {
          this.duplicateAccount.data = res.data.data.map(item => {
            return {
              ...pick(item, [
                "avatar_url",
                "full_name",
                "email",
                "birthday",
                "sex"
              ])
            };
          });
          this.duplicateAccount.total = res.data.total;
        });
    },
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.add-staff-page {
  &__header {
    margin-bottom: 30px;

    .nav-link {
      font-size: 1.5rem;
      color: #1b1f22;
      font-weight: 500;

      cursor: pointer;

      &:hover {
        color: lighten(#1b1f22, 20%);
      }

      span {
        display: inline-block;
        margin-left: 15px;
      }
    }
  }
}

.add-staff-page {
  padding-left: 30px;
  padding-right: 30px;
}
::v-deep .isis-modal-content .isis-modal-header .title[data-v-63dee958] {
  color: #f44336;
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
}
::v-deep .fa-times:before {
  color: #f44336;
}
</style>
